const productDetailPageConstants = {
  APPLE_PAY_MOUNTED: "APPLE_PAY_MOUNTED",
  APPLE_PAY_UNMOUNTED: "APPLE_PAY_UNMOUNTED",
  PRODUCT_DETAIL_SUCCEED: "PRODUCT_DETAIL_SUCCEED",
  PRODUCT_DETAIL_FAILED: "PRODUCT_DETAIL_FAILED",
  PRODUCT_DETAIL_RESET: "PRODUCT_DETAIL_RESET",
  QUICK_VIEW_SELECT: "QUICK_VIEW_SELECT",
  QUICK_VIEW_CLEAR: "QUICK_VIEW_CLEAR",
  PRODUCT_INVENTORY_SUCCEED: "PRODUCT_INVENTORY_SUCCEED",
  PRODUCT_INVENTORY_FAILED: "PRODUCT_INVENTORY_FAILED",
  SET_SELECTED_SIZE: "SET_SELECTED_SIZE",
  PDP_PROMO_SUCCEED: "PDP_PROMO_SUCCEED",
  PDP_SET_SIZE_SELECTION_ERROR: "PDP_SET_SIZE_SELECTION_ERROR",
  SET_SELECTED_GIFT_AMOUNT: "SET_SELECTED_GIFT_AMOUNT",
  INSTOCK: "INSTOCK",
  TOGGLE_PRODUCT_DETAILS: "TOGGLE_PRODUCT_DETAILS",
  METAL_SELECTED: "METAL_SELECTED",
  PDP_RESET_SIZE_SELECTION_ERROR: "PDP_RESET_SIZE_SELECTION_ERROR",
  PDP_SET_SIZE_CHART_VIEW: "PDP_SET_SIZE_CHART_VIEW",
  SIZE_KIT_ORDER_IN_PROGRESS: "SIZE_KIT_ORDER_IN_PROGRESS",
  SIZE_KIT_ORDER_SUCCESS: "SIZE_KIT_ORDER_SUCCESS",
  SIZE_KIT_ORDER_ERROR: "SIZE_KIT_ORDER_ERROR",
  SIZE_KIT_FORM_RESET: "SIZE_KIT_FORM_RESET",
  NOTIFY_USER_FORM_SUCCESS: "NOTIFY_USER_FORM_SUCCESS",
  NOTIFY_USER_FORM_FAILURE: "NOTIFY_USER_FORM_FAILURE",
  NOTIFY_USER_FORM: "NOTIFY_USER_FORM",
}

export default productDetailPageConstants
